module.exports = __webpack_public_path__ + "img/max-file-search--csv.8e924da0.svg";